import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I'm <span className="purple">Janarddan Sarkar</span> — an <strong>AI Engineer</strong> and <strong>Data Scientist</strong> from <strong>Assam, India</strong>, specializing in <strong>Generative AI</strong>, <strong>Large Language Models (LLM)</strong>, <strong>RAG Systems</strong>, and <strong>Deep Learning</strong>. I thrive on persistence, adaptability, and creative problem-solving, whether building intelligent AI agents, developing RAG-powered chatbots, or exploring cutting-edge machine learning technologies. My expertise includes <strong>Natural Language Processing</strong>, <strong>Computer Vision</strong>, and <strong>AI Agent Development</strong>. I believe in growing both mind and health, bringing that balance to every project. For me, challenges aren't roadblocks — they're opportunities to innovate in the field of artificial intelligence.
            <br />
            <br />
            Apart from coding and AI development, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Cricket
            </li>
            <li className="about-activity">
              <ImPointRight /> Photography
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "- Not an expert—just someone who makes things work."
          </p>
          <p style={{ color: "rgb(155 126 172)" }}>
            "- Either grow your health or grow your mind — the best do both."
          </p>
          <footer className="blockquote-footer">Janarddan</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
